export const colorClasses = {
  red: 'bg-red-400',
  blue: 'bg-teal-400',
  yellow: 'bg-yellow-400',
  brown: 'bg-amber-700',
  white: 'bg-white border-2 border-gray-300',
  pink: 'bg-pink-300',
  gray: 'bg-gray-400',
  orange: 'bg-orange-500',
  green: 'bg-green-300',
  purple: 'bg-purple-300'
};